// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loading_loadingContainer__DY3uB","loadingText":"Loading_loadingText__GRhgf"};